import { Link } from 'react-router-dom';

const knowledgeItems = [
  {
    icon: 'ri-guide-line',
    title: 'Come Funziona',
    desc: 'Scopri il funzionamento completo dello spreadsheet itaobuy e impara a navigare tra le categorie.',
    link: '/guida-completa#come-funziona',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20instructional%20guide%20concept%20with%20open%20notebook%20and%20clean%20stationery%20on%20warm%20cream%20desk%2C%20soft%20Mediterranean%20natural%20window%20light%2C%20minimal%20organized%20workspace%2C%20terracotta%20and%20sage%20green%20style%20accents%2C%20sophisticated%20learning%20aesthetic&width=400&height=280&seq=kb-howto&orientation=landscape',
  },
  {
    icon: 'ri-table-line',
    title: 'Tabella Confronto',
    desc: 'Confronta le diverse categorie prodotto per trovare esattamente ci\u00f2 che cerchi nello shopping.',
    link: '/confronto-categorie',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20comparison%20chart%20layout%20with%20clean%20organized%20product%20cards%20on%20warm%20cream%20surface%2C%20minimal%20editorial%20data%20visualization%2C%20soft%20natural%20lighting%2C%20Mediterranean%20aesthetic%2C%20sophisticated%20infographic%20style%20with%20terracotta%20accents&width=400&height=280&seq=kb-confronto&orientation=landscape',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Sicurezza Acquisti',
    desc: 'Tutte le informazioni sulla sicurezza degli acquisti e sulla protezione dei tuoi dati personali.',
    link: '/sicurezza-acquisti',
    image: 'https://readdy.ai/api/search-image?query=Minimal%20security%20shield%20concept%20on%20warm%20cream%20background%20with%20soft%20shadow%20play%2C%20elegant%20Mediterranean%20aesthetic%2C%20clean%20sophisticated%20composition%2C%20subtle%20sage%20green%20accent%20element%2C%20trustworthy%20professional%20visual%20style&width=400&height=280&seq=kb-sicurezza&orientation=landscape',
  },
  {
    icon: 'ri-bookmark-line',
    title: 'Guida Principianti',
    desc: 'Sei nuovo? Inizia da qui con la nostra guida passo-passo per muovere i primi passi.',
    link: '/guida-completa#principianti',
    image: 'https://readdy.ai/api/search-image?query=Welcoming%20beginner%20guide%20concept%20with%20simple%20illustrated%20steps%20on%20warm%20cream%20notebook%2C%20soft%20natural%20light%2C%20minimal%20Mediterranean%20workspace%2C%20terracotta%20and%20sage%20green%20accents%2C%20clean%20approachable%20aesthetic&width=400&height=280&seq=kb-beginner&orientation=landscape',
  },
  {
    icon: 'ri-lightbulb-line',
    title: 'Consigli Esperti',
    desc: 'I migliori suggerimenti dagli esperti per ottimizzare la tua esperienza di shopping con itaobuy sheet.',
    link: '/guida-completa#consigli',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20glowing%20light%20bulb%20concept%20on%20warm%20cream%20desk%20with%20stylish%20notebook%2C%20soft%20Mediterranean%20lighting%2C%20minimal%20sophisticated%20composition%2C%20terracotta%20and%20sage%20green%20accents%2C%20creative%20inspiration%20aesthetic&width=400&height=280&seq=kb-tips&orientation=landscape',
  },
  {
    icon: 'ri-question-answer-line',
    title: 'FAQ Complete',
    desc: 'Risposte alle domande pi\u00f9 frequenti su itaobuy spreadsheet, aggiornate regolarmente.',
    link: '/guida-completa#faq',
    image: 'https://readdy.ai/api/search-image?query=Minimal%20question%20and%20answer%20concept%20with%20elegant%20typography%20cards%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20Mediterranean%20editorial%20aesthetic%2C%20clean%20organized%20composition%2C%20terracotta%20accent%20tabs&width=400&height=280&seq=kb-faq&orientation=landscape',
  },
];

export default function KnowledgeBase() {
  return (
    <section className="bg-background-100 py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-14 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full border border-accent-300/50 text-xs font-medium text-accent-700 mb-6">
            Knowledge Base
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Guide &amp; Approfondimenti
          </h2>
          <p className="font-heading text-4xl md:text-5xl text-foreground-500 font-light italic mt-1">
            Itaobuy Sheet
          </p>
          <p className="text-sm text-foreground-500 mt-6 max-w-lg mx-auto">
            Una raccolta completa di guide, tutorial e approfondimenti per padroneggiare lo shopping con itaobuy spreadsheet.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {knowledgeItems.map((item) => (
            <Link
              key={item.title}
              to={item.link}
              className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="aspect-[4/3] w-full overflow-hidden bg-background-200/50">
                <img
                  src={item.image}
                  alt={`${item.title} - itaobuy spreadsheet`}
                  title={`${item.title} - Itaobuy Spreadsheet Italia`}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 rounded-lg bg-background-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                    <i className={`${item.icon} text-lg text-primary-500 group-hover:text-white transition-colors duration-300 w-5 h-5 flex items-center justify-center`}></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-300">
                    {item.title}
                  </h3>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-xs font-medium text-foreground-400 group-hover:text-primary-600 transition-colors duration-300 whitespace-nowrap">
                  Scopri di pi&ugrave; <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <Link
            to="/guida-completa"
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-foreground-950 text-background-50 font-medium text-sm hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line text-base"></i>
            Apri la Guida Completa
          </Link>
        </div>
      </div>
    </section>
  );
}